/** Display name for a workout duration from its assigned plan titles. */
export function durationPlanName(duration) {
  const explicit =
    duration?.title || duration?.name || duration?.plan_name || duration?.planName;
  if (explicit && String(explicit).trim()) return String(explicit).trim();

  const titles = [];
  const seen = new Set();
  for (const day of duration?.weekdays || []) {
    for (const plan of day.plans || []) {
      const t = (plan.title || '').trim();
      if (!t) continue;
      const key = t.toLowerCase();
      if (seen.has(key)) continue;
      seen.add(key);
      titles.push(t);
    }
  }

  if (!titles.length) return 'Workout plan';
  if (titles.length === 1) return titles[0];
  if (titles.length === 2) return titles.join(' · ');
  return `${titles[0]} +${titles.length - 1}`;
}
